module.exports = __webpack_public_path__ + "img/sword.0e02747a.svg";